<template lang="pug">
	
	.land-of-free
		.background-image(ref='bg')
			.layer
			img(src="assets/images/land-of-free.jpg" ref='bgImg')
			

		.interview-wrapper

			h2.title(v-html="translate('land_of_free.title')")

			.about-birthday 
				p.text(v-html="translate('land_of_free.text_1')" ref='text0')

			.about-clip
				blockquote(v-html="translate('land_of_free.quote_1')" ref='text1')
				p.text(v-html="translate('land_of_free.text_2')" ref='text2')

			.about-president
				blockquote(v-html="translate('land_of_free.quote_2')" ref='text3')
				p.translation(v-html="translate('land_of_free.translate_2')" ref='text4')

			.about-storyboard
				p.text(v-html="translate('land_of_free.text_3')" ref='text5')

		background
</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scrollable from '~abstracts/scrollable'
	import Background from '../../components/background.vue'


  	@Component({
		name: 'LandOfFree',
		components: { Background }
	})

	class LandOfFree extends Scrollable {

		mounted () {
			super.mounted()

			this._dom()
		}

		init () {
			super.init()

			this.isResized = false
		}

		_bind () {
			super._bind()
		}

		_dom () {
			this.$bg = this.$el.querySelector('.background-image')
			this.$bgLayer = this.$bg.querySelector('.layer')
		}

		initTimeline () {
			super.initTimeline()
			
			const hw_ratio = (window.innerHeight / 3) / this.bounds.height

			const appearTime = window.innerHeight / (this.bounds.height + window.innerHeight * 2)
			

			// for(let i = 0; i < 6; i++) {
			// 	const el = this.$refs[`text${i}`]
			// 	const b = el.getBoundingClientRect()
				
			// 	const textAppearTime = (b.top - this.bounds.top + b.height * .5) / (this.bounds.height + window.innerHeight * 2)
			// 	const textAnimTime = b.height * .8 / (this.bounds.height + window.innerHeight * 2)				
			// 	this.tl.fromTo(el,textAnimTime,{y:0,opacity:0},{y:0,opacity:1, ease:Power0.easeNone},textAppearTime)
			// }

		
			TweenMax.set(this.$refs.bgImg,{opacity:0})

			this.tl.add(()=>{

				if(this.scroller.scroll.direction === 1 || this.isResized == false) {
					TweenMax.set(this.$refs.bgImg,{opacity: 1})
				} else {
					TweenMax.set(this.$refs.bgImg,{opacity: 0})
				}
				this.isResized = true
			},appearTime)

			this.tl.fromTo(this.$bg,1,{y:-window.innerHeight},{y:this.bounds.height + window.innerHeight, ease:Power0.easeNone},0)
			this.tl.fromTo(this.$bgLayer,.2,{opacity:0},{opacity:.7, ease:Power0.easeNone},0)
		}


		raf (y) {
			super.raf(y)

			// console.log(this.perc)
		}

		_resize () {
			super._resize()

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.bounds.height + window.innerHeight
			}

			this.initTimeline ()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default LandOfFree

</script>


<style lang="stylus">
	
	@import '../../theme/utils'
	@import '../../theme/variables'
	
	.land-of-free
		width 100%
		min-height 100vh
		background #0f0d37
		position relative
		padding-bottom 10%
		z-index 50
		background-color transparent

		+break(xs)
			padding-bottom 50px

		.background
			z-index 30

		.background-image
			position absolute
			top 0
			left 0
			height 100vh
			width 100%
			z-index 20
			will-change transform
			// opacity 0

			.layer
				position absolute
				top 0
				left 0
				bottom 0
				right 0
				background-color rgba(0,0,0,1)
				opacity 0

			img
				width 100%
				height 100%
				object-fit cover

		.interview-wrapper
			position relative
			z-index 70
			padding-top 5vh
			text-align center

			.title
				color #fff
				font-size em(100px)
				font-weight 700

			.text
				color #fff
				font-size em(18px)
				line-height em(24px,18px)
				font-family $FONT_THIRDLY
				max-width 600px
				margin auto

				+break(xs)
					font-size em(16px)

				span
					font-size em(18px)
					font-family $FONT_PRIMARY

			blockquote
				color #fff
				font-size em(30px)
				line-height em(40px,30px)
				font-family $FONT_PRIMARY
				max-width 800px
				margin auto

			.translation
				max-width 360px
				margin auto	
				color #fff
				font-size em(15px)
				line-height em(21px,15px)
				letter-spacing .15em
				font-family $FONT_SECONDARY
				font-weight 300
				text-transform uppercase

			.about-birthday
				margin-top 80px
			
			.about-clip
				margin-top 70px

				+break(xs)
					margin-top 50px

				.text
					margin-top 130px

					+break(xs)
						margin-top 50px

			.about-president
				margin-top 42px

				.translation
					margin-top 20px

			.about-storyboard
				margin-top 50px
	

</style>


// WEBPACK FOOTER //
// land-of-free.vue?9e48288c